import { Query } from '@apollo/client/react/components';
import { useMutation, useQuery } from '@apollo/client';
import {
  newTicketConstraints,
  validateForm,
  getTranslatedText,
  EventEmitter,
  AccessControl,
  getHeaderValue,
  getEntityAttributes,
  ENTITY_MAP,
  isAuthorised,
  FeatureGuide,
  formatFormTemplate,
  fetchApi,
  COMMON_CONSTANTS,
  getParsedCrudData,
  PSA_CONSTANTS,
  useProduct
} from '@nile/components';
import {
  DualCell,
  ClientSelect,
  UserSelect
} from '@nile/mangifera/src/Components/Ticket';
import {
  GET_PUBLISHED_TICKET_FORMS,
  GET_PUBLISHED_TICKET_FORMS_NEW,
  RMMClient,
  UPDATE_TICKET_ASSETS,
  MLClient,
  AccountClient
} from '@nile/graphql';
import { GENERATE_TICKET_DEFLECTION_SUGGESTIONS_V2 } from '@nile/rmm/src/modules/knowledge-base/graphql/query';
import { GET_AI_FEATURES_LIST_INDIVIDUAL } from '@nile/banyan/src/Graphql/Query/ai';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import {
  Button,
  ButtonGroup,
  Page,
  Heading,
  Avatar,
  Spinner,
  TextStyle,
  Card,
  Tippy,
  Badge,
  Modal
} from '@superops/ui-design-system';
import {
  getAccessor,
  getCellType,
  getDependantField,
  getParentField,
  isDependantField
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { cloneDeep, isEmpty, pick, sortBy } from 'lodash';
import React, { Component, useContext } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Select from 'react-select';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import TicketScheduleModal from '@nile/banyan/src/Containers/SheetContainers/TicketScheduleModal';
import { SVGIcon } from '@superops/super-icons';
import WorklogHoursSection from '@nile/components/src/Containers/Worklog/WorklogHoursSection';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { GET_ASSETS_FILTER } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import AssetTypeCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-type-cell';
import TicketAssetsSheet from '@nile/mangifera/src/Containers/SheetContainers/TicketAssetsSheet';
import { isFeatureAvailable } from '@nile/components/src/HOC/withPlanFeatureGating';
import TicketTypeContainer from '@nile/mangifera/src/Components/Ticket/TicketTypeContainer';
import { removePropertiesForItProduct } from '@nile/itsm';
import SiteSelect from '@nile/projects/src/Components/Inputs/SiteSelect';
import { DepartmentSelect } from '@nile/itsm/src/pages/components/DepartmentSelect';
import TicketForm from './TicketForm';
import { GET_CLIENTS_FOR_DROPDOWN } from '@nile/graphql/src/Mutation/client';
import KbRelevantArticle from './kbRelevantArticle';
import { GET_TICKET_FORMS_BY_REQUESTER_GROUP } from '@nile/itsm/src/graphql';

const PARENT_FIELD_MAP = {
  CATEGORY: 'category',
  CAUSE: 'cause'
};

const DEPENDANT_MAP = {
  [PARENT_FIELD_MAP.CATEGORY]: 'subcategory',
  [PARENT_FIELD_MAP.CAUSE]: 'subcause'
};

export const Wrapper = styled.div`
  .formTemplates .Superops-Avatar__Image {
    width: 20px;
    height: 20px;
    background: #afcf8d;
  }
  .formTemplates .Superops-Avatar--hasImage {
    background: #afcf8d;
  }
  .source {
    border-bottom: 1px solid #ececec;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
  }
  .subject-wrapper {
    padding: 0 20px;
  }
  .subject-wrapper .Superops-TextField__Backdrop {
    border-bottom: none;
  }
  .editor-holder {
    padding: 0 20px;
    padding-bottom: 2rem;
  }
  .Header-Input {
    max-width: 100% !important;
  }
  .technician-select {
    .Superops-Avatar {
      background: linear-gradient(180deg, #88f0ff 0%, #75a6ff 97.04%);
      text-transform: uppercase;
      font-size: 16px;
      font-weight: 600;
    }
    .closeIcon {
      visibility: hidden;
      position: relative;
      top: 3px;
      right: 20px;
    }

    &:hover {
      .closeIcon {
        visibility: visible;
      }
    }
  }
  .pageAct {
    flex-grow: 1;
    justify-content: center;
  }

  .custom-form-layout {
    width: 100%;
    border: none;
  }

  .custom-form-layout-card {
    height: 100%;
    padding: 0 20px;
    border-top: 1px solid #ececec;
    padding-top: 2rem;
  }
  .react-grid-layout {
    border: none;
    width: 100% !important;
  }

  .actionsWrapper {
    border-bottom: 1px solid #ececec;
  }
  .rdw-editor-wrapper {
    height: auto !important;
    display: flex;
    background: #ffffff;
    flex-direction: column-reverse;
    margin: 2px;
  }

  .TabPage {
    justify-content: center;
    overflow: auto;
    height: calc(100% - 180px);
  }
  .value_selector__control {
    min-width: 160px;
    border-bottom: 0 !important; // todo: DSA.
  }
  .value_selector__menu {
    z-index: 400;
  }

  .custom-form-layout-card {
    .Superops-Labelled__Error {
      display: none;
    }
  }
`;

const Field = styled.div`
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;

const RequesterUserContainer = styled.div`
  .Superops-Avatar__Image {
    width: 20px;
    height: 20px;
    background: #ad92fb !important;
  }
  .Superops-Avatar--hasImage {
    background: #ad92fb !important;
  }
`;

const ScheduleButton = styled.div`
  margin: -10px -30px -10px -16px;
  padding: 10px 30px 10px 16px;
`;

const WorkLogHourSectionContainer = styled.div`
  max-width: 450px;
`;

export function AssociateAssets(props) {
  const { ticket, assets, addedAssets } = props;
  const tabContext = useContext(TicketContext);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const [associateAssetsWithTicket] = useMutation(UPDATE_TICKET_ASSETS);
  const { loading, data, error } = useQuery(GET_ASSETS_FILTER, {
    client: RMMClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      viewType: ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: isMSPProduct ? 'client.accountId' : 'site.id',
              operator: 'is',
              value: isMSPProduct ? ticket?.client?.accountId : ticket?.site?.id
            },
            {
              attribute: 'owner.userId',
              operator: 'is',
              value: ticket.requester?.userId
            }
          ]
        }
      }
    }
  });
  if (loading) return <div>loading...</div>;
  if (error) return <div>error...</div>;
  const associatedAssets = data.getAllAssets?.assets?.filter(
    (el) => !assets?.some((ast) => ast.assetId === el.assetId)
  );
  const associateAssets = (asset) => {
    const currentAssociatedAssets = props.assets || [];
    const newAssociatedAssets = [asset];
    const parsedObject = getParsedCrudData(
      currentAssociatedAssets,
      newAssociatedAssets,
      'assetId'
    );
    associateAssetsWithTicket({
      variables: {
        id: ticket.ticketId,
        addAssets: parsedObject.addedItems.map((el) => {
          return {
            assetId: el.assetId
          };
        })
      },
      input: {
        id: ticket.ticketId,
        addAssets: parsedObject.addedItems.map((el) => {
          return {
            assetId: el.assetId
          };
        })
      }
    }).then((res) => {
      if (res?.data?.updateTicket) {
        toast('success', 'Asset associated successfully');
      }
      props.refetchAssets();
    });
  };
  return (
    <div id="associate-asset-list-wrapper">
      {associatedAssets?.length > 0 ? (
        associatedAssets.map((el) => {
          return (
            <div className="flex asset actr hiddenContainer lh-40">
              <AssetTypeCell cell={{ row: { original: el } }} />
              <div
                className="ellipsis ml8"
                onClick={() => {
                  tabContext.openTab({
                    module: 'ASSET_DETAILS',
                    data: {
                      id: el.assetId,
                      classId: el?.assetClass?.classId,
                      subject: el?.name
                    }
                  });
                }}
              >
                <TextStyle weight="Medium">{el.name}</TextStyle>
              </div>

              <AccessControl
                roleToCheck="tickets.edit"
                render={
                  <div className="mlauto">
                    <Tippy interactive title="Associate">
                      <Button
                        id="psaAssociateAssets"
                        size="small"
                        onClick={addedAssets.bind(this, { addAssets: [el] })}
                        icon={<SVGIcon name="RightArrowCircle" />}
                      />
                    </Tippy>
                  </div>
                }
              />
            </div>
          );
        })
      ) : (
        <div className="mt10">
          <FormattedMessage id="ticket.details.insights.assets.noAssets" />
        </div>
      )}
    </div>
  );
}

class TicketSheet extends Component {
  constructor(props) {
    super(props);
    const currentUser = this.props.appContext?.user;
    const isMSPProduct =
      props.appContext.currentProduct === COMMON_CONSTANTS.MSP;
    const isMSPClient = currentUser?.accountType === 'CLIENT' && isMSPProduct;
    const assignedClient = props.appContext?.user?.associations?.[0]?.client;
    const clientId = isMSPClient
      ? this.props.homeContext?.multiSiteAssociations?.[0]?.client?.accountId
      : props.appContext?.user?.associations?.[0]?.client?.accountId;
    const userAssociations = isMSPClient
      ? this.props.homeContext?.multiSiteAssociations
      : props.appContext?.user?.associations;
    const userDepartment = props.appContext?.user?.businessFunction;
    const clientList = userAssociations?.map((c) => {
      return {
        name: c.org.name,
        accountId: c.org.accountId
      };
    });
    const userId = props.appContext?.user?.userId;
    const isClient = props.appContext.accountType === 'CLIENT';
    const userRole = currentUser?.role?.roleFeatureList || [];
    const isAssetAuthorised = isAuthorised(userRole, 'asset.view');
    const isAssetGatingAvailable = isFeatureAvailable(
      props.appContext.planFeatureList,
      'WINDOWS_MANAGEMENT'
    );

    const defaultTechnician =
      this.props.isMsp && currentUser
        ? {
            userId: currentUser?.userId,
            firstName: currentUser?.firstName,
            lastName: currentUser?.lastName
          }
        : null;
    const defaultTicketData = {
      subject: '',
      client: {
        accountId: isClient ? clientId : null,
        name: isClient ? assignedClient?.name : null
      },
      requester: isClient ? { userId: userId } : null,
      ticketType: null,
      technician: defaultTechnician
    };
    if (!isMSPProduct) {
      defaultTicketData.department = userDepartment || null;
    }

    const ticket = props.ticket
      ? JSON.parse(JSON.stringify(props.ticket))
      : props.activeTab?.state?.ticket || defaultTicketData;

    this.state = {
      editMode: false,
      template: props.activeTab?.state?.template || {
        name: '',
        content: '',
        placeholdersUsed: '',
        attachments: []
      },
      source: props.activeTab?.state?.source,
      ticket: ticket,
      selectedFormTemplate: null,
      errors: {},
      submitActionLoading: false,
      isUploading: false,
      scheduleModalOpen: false,
      mandatoryFieldsOnCreation: [],
      imageUploading: false,
      checkClient: isClient,
      associateTimer: props?.context?.activeTab?.data?.associateTimer,
      isAssetAuthorised: isAssetAuthorised,
      isAssetGatingAvailable: isAssetGatingAvailable,
      sheetActive: false,
      clientList: clientList,
      userAssociations: userAssociations,
      showAdditionalRequester: !isEmpty(ticket?.addAdditionalRequester),
      confirmDeflectionModalOpen: false,
      suggestions: '',
      isTicketDeflectionActive: false,
      ticketDeflectionClientConfigType: 'ALL',
      ticketDeflectionClientList: []
    };
    this.editorRef = React.createRef();
    this.timerRef = React.createRef();
    this.isMSPClientProduct = isMSPClient;
  }

  runbookRevampFlag = this.props.flags?.unifiedRunbooks;
  requesterGroupsFlag = this.props.flags?.requesterGroups;

  // Determine which query to use for ticket forms based on flags and user state
  getTicketFormsQuery = (isMSPProduct) => {
    const hasRequester = Boolean(this.state.ticket?.requester?.userId);

    /** Get the Ticket Forms by Requester Group */
    if (this.requesterGroupsFlag && !isMSPProduct && hasRequester) {
      return GET_TICKET_FORMS_BY_REQUESTER_GROUP;
    }
    if (this.runbookRevampFlag) {
      return GET_PUBLISHED_TICKET_FORMS_NEW;
    }
    return GET_PUBLISHED_TICKET_FORMS;
  };

  getFormsPayload = (data, isMSPProduct) => {
    const hasRequester = Boolean(this.state.ticket?.requester?.userId);

    if (this.requesterGroupsFlag && !isMSPProduct && hasRequester) {
      return data?.getTicketFormsByRequesterGroup || [];
    }
    if (this.runbookRevampFlag) {
      return data?.getPublishedTicketForms || [];
    }
    return data?.getPublishedTicketForms || [];
  };

  componentDidMount() {
    EventEmitter.subscribe('tabChange', this.updateTabState);
    EventEmitter.subscribe('imageUploading', this.setImageUploading.bind(this));
    const formFromTabState = !isEmpty(
      this.props.activeTab?.state?.selectedFormTemplate
    )
      ? this.props.activeTab?.state?.selectedFormTemplate
      : null;
    const defaultTicketForm = !isEmpty(this.props.defaultTicketForm)
      ? this.props.defaultTicketForm
      : null;
    if (formFromTabState || defaultTicketForm) {
      this.setState({
        selectedFormTemplate: formFromTabState || defaultTicketForm
      });
    }

    // Call the GET_AI_INDIVIDUAL_FEATURES API for "TICKET_DEFLECTION" when component mounts
    if (
      this.props.appContext?.currentProduct === COMMON_CONSTANTS.MSP &&
      this.props.appContext?.accountType === 'CLIENT'
    ) {
      AccountClient.query({
        query: GET_AI_FEATURES_LIST_INDIVIDUAL,
        variables: {
          input: {
            listInfo: {
              condition: {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'featureId',
                    operator: 'is',
                    value: 12
                  }
                ]
              }
            }
          }
        },
        fetchPolicy: 'network-only'
      })
        .then((response) => {
          if (response?.data?.getAIFeatureList) {
            const feature = response.data.getAIFeatureList?.feature;
            if (feature[0]?.clientConfigType === 'ALL') {
              this.setState({
                ticketDeflectionClientConfigType: feature[0]?.clientConfigType,
                isTicketDeflectionActive: feature[0]?.state === 'ACTIVE'
              });
            } else {
              this.setState({
                ticketDeflectionClientConfigType: feature[0]?.clientConfigType,
                ticketDeflectionClientList: feature[0]?.clients,
                isTicketDeflectionActive: feature[0]?.state === 'ACTIVE'
              });
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching ticket deflection:', error);
        });
    }
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('tabChange');
    EventEmitter.unsubscribe('imageUploading');
  }

  updateTabState = (eventData) => {
    this.props.context.updateTabState(
      {
        ticket: this.state.ticket,
        selectedFormTemplate: this.state.selectedFormTemplate,
        template: this.state.template
      },
      eventData
    );
  };

  getSiteByOrgAccountId = (accountId = null) => {
    const clientId = accountId || this.state.ticket.client.accountId;
    const assingedSite = this.state.userAssociations.find(
      (item) => item?.org?.accountId === clientId
    );
    return assingedSite ? [assingedSite.site] : null;
  };

  getNestedChilds = (currentField, meta) => {
    const nestedChild = [];
    if (currentField?.nestedAttributes) {
      const getChilds = (fld) => {
        fld?.nestedAttributes?.map((el) => {
          const child = meta?.attributes?.find((attr) => attr?.name === el);
          if (child) {
            nestedChild.push(child);
            if (child?.nestedAttributes) {
              getChilds(child);
            }
          }
        });
      };
      getChilds(currentField);
    }
    return nestedChild;
  };

  propertiesToAppendMap = {
    client: {
      requester: null,
      addAdditionalRequester: [],
      site: null
    },
    site: {
      requester: null,
      addAdditionalRequester: null
    }
  };

  updateDepedentFormField = (key, field, additionalProps = null) => {
    const ticketFields = this.props.entitiesMeta?.getEntitiesMeta?.find(
      (el) => el?.name === 'Ticket'
    );
    const currentFld = ticketFields?.attributes?.find(
      (attr) => attr?.name === key
    );
    const req = { ...this.state?.ticket?.requester };
    let propertiesToAppend = {};
    let customFields = { ...this.state?.ticket?.customFields };
    let updatedFieldLayout = this.state?.selectedFormTemplate
      ? JSON.parse(this.state?.selectedFormTemplate?.fieldDetails)?.layout
      : [];

    if (
      this.props?.appContext?.accountType !== 'CLIENT' &&
      key === 'client' &&
      req?.userId
    ) {
      propertiesToAppend = { requester: null };
    }

    const defaultPropertiesToAppend = this.propertiesToAppendMap?.[key];
    if (defaultPropertiesToAppend) {
      propertiesToAppend = {
        ...propertiesToAppend,
        ...defaultPropertiesToAppend
      };
    }
    if (!isEmpty(currentFld?.nestedAttributes)) {
      const resetFldValue = this.getNestedChilds(currentFld, ticketFields);
      if (!isEmpty(resetFldValue)) {
        const customFldReset = resetFldValue?.filter((el) => el?.isCustom);
        updatedFieldLayout = updatedFieldLayout?.map((el) => ({
          ...el,
          field: {
            ...el?.field,
            fieldProps: resetFldValue.some(
              (f) => f.name === el?.field?.fieldProps?.name
            )
              ? {
                  ...el?.field?.fieldProps,
                  defaultValue: null,
                  selectedValue: null
                }
              : el?.field?.fieldProps
          }
        }));

        if (!isEmpty(customFldReset)) {
          customFldReset?.map(
            (el) => (customFields = { ...customFields, [el?.name]: null })
          );
          propertiesToAppend = {
            ...propertiesToAppend,
            customFields
          };
        }

        const defaultFldReset = resetFldValue?.filter((el) => !el?.isCustom);
        defaultFldReset?.map(
          (el) =>
            (propertiesToAppend = { ...propertiesToAppend, [el?.name]: null })
        );
      }
    }
    if (key === 'client' && this.props.appContext?.accountType === 'CLIENT') {
      const site = this.getSiteByOrgAccountId(field?.accountId);
      if (site?.length > 0) {
        propertiesToAppend = {
          ...propertiesToAppend,
          site: site[0]
        };
      }
    }
    if (additionalProps && additionalProps?.additionalFields) {
      this.setState((prevState) => ({
        ticket: {
          ...prevState.ticket,
          ...propertiesToAppend,
          [key]: field,
          ...additionalProps
        }
      }));

      if (!isEmpty(updatedFieldLayout)) {
        this.setState((prevState) => ({
          selectedFormTemplate: {
            ...prevState?.selectedFormTemplate,
            fieldDetails: JSON.stringify({ layout: updatedFieldLayout })
          }
        }));
      }
      return;
    }
    this.setState((prevState) => ({
      ticket: {
        ...prevState.ticket,
        ...propertiesToAppend,
        [key]: field
      }
    }));
  };

  updateField = (key, field, additionalProps = null) => {
    if (this?.props?.flags?.dependentField) {
      this.updateDepedentFormField(key, field, additionalProps);
      return;
    }
    const dependantField = DEPENDANT_MAP?.[key];
    const req = { ...this.state?.ticket?.requester };
    let propertiesToAppend = {};
    if (
      this.props?.appContext?.accountType !== 'CLIENT' &&
      key === 'client' &&
      req?.userId
    ) {
      propertiesToAppend = { requester: null };
    } else if (dependantField) {
      propertiesToAppend = { [dependantField]: null };
    }

    const defaultPropertiesToAppend = this.propertiesToAppendMap?.[key];
    if (defaultPropertiesToAppend) {
      propertiesToAppend = {
        ...propertiesToAppend,
        ...defaultPropertiesToAppend
      };
    }

    if (additionalProps && additionalProps?.additionalFields) {
      // IT product case, auto update department field.
      // set requester to null if site is updated
      this.setState((prevState) => ({
        ticket: {
          ...prevState.ticket,
          ...propertiesToAppend,
          [key]: field,
          ...additionalProps
        }
      }));
      return;
    }

    this.setState((prevState) => ({
      ticket: {
        ...prevState.ticket,
        ...propertiesToAppend,
        [key]: field
      }
    }));
  };

  updateSiteUser = (siteUserData) => {
    for (let siteuser in siteUserData) {
      this.updateField(siteuser, siteUserData[siteuser]);
    }
  };

  clearTechnician = () => {
    const updatedTicket = { ...this.state.ticket };
    delete updatedTicket.technician;
    this.setState((prevState) => ({
      ticket: updatedTicket
    }));
  };

  updateProperties = (properties) => {
    this.setState((prevState) => ({
      ticket: {
        ...prevState.ticket,
        ...properties
      }
    }));
  };

  save = () => {
    const { appContext, flags, aiFeatureHook } = this.props;
    const { getIsAIFeatureEnabled } = aiFeatureHook;
    const { currentProduct, accountType, user } = appContext;
    const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;
    const {
      ticket,
      template,
      selectedFormTemplate,
      mandatoryFieldsOnCreation
    } = this.state;

    const form = selectedFormTemplate || null;
    const currentFormLayout = form?.fieldDetails
      ? JSON.parse(form?.fieldDetails)?.layout
      : [];

    const allFields = currentFormLayout.map((el) => ({
      name: el?.field?.fieldProps?.label,
      columnName: el?.field?.fieldProps?.name,
      type: el?.field?.type
    }));

    const mandatoryFieldsOnCurrentForm = allFields.filter((el) =>
      mandatoryFieldsOnCreation.some((f) => f?.columnName === el?.columnName)
    );

    let ticketConstraints = { ...newTicketConstraints };
    if (isMSPProduct) {
      ticketConstraints = {
        ...ticketConstraints,
        'client.accountId': {
          presence: {
            allowEmpty: false,
            message: '^Client must be selected'
          }
        }
      };
    } else {
      ticketConstraints = {
        ...ticketConstraints,
        'site.id': {
          presence: {
            allowEmpty: false,
            message: '^Site must be selected'
          }
        }
      };
    }

    mandatoryFieldsOnCurrentForm.forEach((el) => {
      const type = el?.type;
      const key =
        type === 'default' ? el.columnName : `customFields.${el.columnName}`;
      const newConstraint = {
        [key]: {
          presence: {
            allowEmpty: false,
            message: `^${el?.name} cannot be empty`
          }
        }
      };
      ticketConstraints = { ...ticketConstraints, ...newConstraint };
    });

    /* ask backend to change id to ticketId */
    if (ticket.ticketId) {
      ticket.id = ticket.ticketId;
    }
    ticket.description = dompurifier(template.content);
    if (
      (selectedFormTemplate &&
        selectedFormTemplate?.standardOperatingProcedure?.sopId) ||
      selectedFormTemplate?.runbook?.sopId
    ) {
      ticket.sop = {
        sopId:
          selectedFormTemplate?.runbook?.sopId ||
          selectedFormTemplate?.standardOperatingProcedure?.sopId
      };
    }
    const formToValidate = cloneDeep(ticket);
    const validationResult = validateForm(formToValidate, ticketConstraints);
    if (validationResult) {
      this.setState({ errors: validationResult });
      return;
    }

    const ticketDeflectionClientCheck =
      this.state.ticketDeflectionClientConfigType === 'ALL'
        ? true
        : this.state.ticketDeflectionClientList?.find(
            (item) => item?.accountId === this.state.ticket?.client?.accountId
          );

    // Check if AI ticket deflection is enabled
    const isAiTicketDeflectionEnabled =
      accountType === 'CLIENT' &&
      isFeatureAvailable(appContext.planFeatureList, 'KNOWLEDGE_BASE') &&
      this.state.isTicketDeflectionActive &&
      ticketDeflectionClientCheck;

    if (isAiTicketDeflectionEnabled) {
      // Call the API to get deflection suggestions if feature is enabled
      this.getDeflectionSuggestions({
        subject: ticket?.subject,
        description: ticket?.description
      });
    } else {
      // Skip deflection suggestions and create ticket directly
      this.createTicket();
    }
  };

  // Method to handle actual ticket creation after confirmation
  createTicket = (trackEvent = null) => {
    if (trackEvent) {
      this.props.useActivityTracker(trackEvent);
    }
    const { actions, appContext } = this.props;
    const { currentProduct, user } = appContext;
    const isAgentVersionUpdated =
      user?.rmmAppProperties?.betaAgentBasedFeatures?.agentChat;
    const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;
    const { ticket, template, selectedFormTemplate } = this.state;

    this.setState({
      errors: {},
      submitActionLoading: true,
      confirmDeflectionModalOpen: false
    });

    if (actions.primaryAction) {
      const inputParams = {
        ...this.state.ticket
      };
      // send deparment id only for IT product
      if (!isMSPProduct) {
        inputParams.department = this.state.ticket?.department
          ?.businessFunctionId
          ? {
              businessFunctionId: this.state.ticket?.department
                ?.businessFunctionId
            }
          : null;
      } else {
        // temp fix to remove department field for MSP product TODO: itsm
        delete inputParams.department;
      }

      if (this.state.ticket.description || !isEmpty(template?.attachments)) {
        inputParams.conversation = {
          content: this?.state?.ticket?.description || null,
          attachments: template.attachments?.map(
            ({ fileName, originalFileName, fileSize }) => {
              return { fileName, originalFileName, fileSize };
            }
          ),
          toUsers: [{ email: appContext?.user.email }]
        };
      }

      if (
        this.state?.associateTimer &&
        this.timerRef.current?.getTimerInputObj
      ) {
        inputParams.updateWorklogTimer = this.timerRef.current?.getTimerInputObj;
      }

      if (this.state.selectedFormTemplate?.formId) {
        inputParams.form = {
          formId: this.state.selectedFormTemplate?.formId
        };
      }
      const updatedParams = removePropertiesForItProduct(
        inputParams,
        'saveTicket',
        currentProduct
      );
      const { addAssets = [], ...inputParamsNew } = updatedParams;
      const addAsset = addAssets?.map((el) => {
        return {
          assetId: el.assetId
        };
      });

      const { source } = this.state;

      if (this?.props?.flags?.agentChatFe && isAgentVersionUpdated) {
        const additionalRequesterInput = inputParams?.addAdditionalRequester
          ?.length
          ? inputParams.addAdditionalRequester.map(({ userId }) => ({ userId }))
          : null;

        inputParamsNew.addAdditionalRequester = additionalRequesterInput;

        actions.primaryAction(
          {
            variables: {
              ...inputParamsNew,
              addAssets: addAsset,
              isMSPProduct: isMSPProduct
            },
            input: {
              ...inputParamsNew,
              addAssets: addAsset
            }
          },
          source
        );
      } else {
        const additionalRequesterInput = updatedParams?.addAdditionalRequester
          ?.length
          ? updatedParams.addAdditionalRequester.map(({ userId }) => ({
              userId
            }))
          : null;

        updatedParams.addAdditionalRequester = additionalRequesterInput;

        actions.primaryAction({
          variables: { ...updatedParams, isMSPProduct: isMSPProduct },
          input: { ...updatedParams }
        });
      }
    }
  };

  closeDeflectionModal = (trackEvent) => {
    if (trackEvent) {
      this.props.useActivityTracker(trackEvent);
    }
    this.setState({ confirmDeflectionModalOpen: false });
    // Use TicketContext to navigate to the Tickets tab
    const tabContext = this.props.context;

    if (tabContext && tabContext.openTab) {
      // Navigate to the Tickets workspace
      tabContext.closeAndOpenTab(null, {
        id: 'workspace',
        content: '',
        module: 'WORKSPACE',
        tabId: 'workspace',
        state: {},
        data: {
          isClientPortal: true,
          type: 'TICKETWORKSPACE'
        },
        url: '/ticket/1/ticket-list'
      });
    }
  };

  cancel = () => {
    const { actions, tab } = this.props;
    actions.closeTab(tab);
  };

  setEditorReference = (ref) => {
    this.editorReferece = ref;
  };

  setEditMode = () => {
    const { editMode } = this.state;
    this.setState({ editMode: !editMode });
  };

  handleTemplateChange = (val) => {
    const formattedLayout = formatFormTemplate(val?.fieldDetails, true);
    const updatedFormTemplate = {
      ...val,
      fieldDetails: formattedLayout
    };
    if (this.state.errors) {
      this.setState({
        errors: newTicketConstraints
      });
    }
    this.setState({
      selectedFormTemplate: updatedFormTemplate
    });
  };

  updateTemplate = (obj) => {
    const updatedTemplate = cloneDeep(this.state.template);
    this.setState({ template: { ...updatedTemplate, ...obj } });
  };

  updateSelectedFormTemplate = (updatedTemplate) => {
    this.setState({ selectedFormTemplate: updatedTemplate });
  };

  handleFileAttachments = (files, callback) => {
    const formData = new FormData();
    // formData.append('files', files);
    files.forEach((file, idx) => {
      formData.append(`files`, file);
    });
    formData.append('module', 'TICKET_CONVERSATION_ATTACHMENT');
    this.setState({ isUploading: true });
    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: getHeaderValue()
    };
    fetchApi(`${envConfig.fileRoot}/upload`, requestOptions)
      .then((response) => {
        console.log('email template attachment response is ', response);
        return response.json();
      })
      .then((list) => {
        const updatedTemplate = cloneDeep(this.state.template);
        const updatedList = [...updatedTemplate?.attachments, ...list.data];
        updatedTemplate.attachments = updatedList;
        this.setState({ template: updatedTemplate });
      })
      .catch((err) => {
        console.error('Error:', err);
      })
      .finally(() => {
        this.setState({ isUploading: false });
        if (callback) {
          callback();
        }
      });
  };

  handleAttachmentsDeletion = (fileName) => {
    const updatedTemplate = cloneDeep(this.state.template);
    const updatedList = cloneDeep(updatedTemplate?.attachments).filter(
      (item) => item.fileName !== fileName
    );
    updatedTemplate.attachments = updatedList;
    this.setState({ template: updatedTemplate });
  };

  getDefaultValue = (fieldValue, fieldName) => {
    switch (fieldName) {
      case 'techGroup':
        return fieldValue
          ? {
              ...fieldValue,
              name: fieldValue.name,
              label: fieldValue.name,
              value: fieldValue.name
            }
          : '';
      case 'technician':
        return fieldValue
          ? {
              ...fieldValue,
              name: `${fieldValue.firstName} ${fieldValue.lastName}`,
              label: `${fieldValue.firstName} ${fieldValue.lastName}`,
              value: `${fieldValue.firstName} ${fieldValue.lastName}`
            }
          : '';
      default:
        return fieldValue
          ? { name: fieldValue, label: fieldValue, value: fieldValue }
          : '';
    }
  };

  getCellProps = (col) => {
    const { entitiesMeta } = this.props;
    const allEntityFields = getEntityAttributes(
      entitiesMeta,
      ENTITY_MAP.ticket
    );
    return {
      type: getCellType(col),
      accessor: getAccessor(col),
      editable: true,
      actions: { save: this.updateProperties },
      field: col,
      parentField: isDependantField(col.name)
        ? allEntityFields.find((el) => el.name === getParentField(col.name))
        : col,
      dependantField: isDependantField(col.name)
        ? col
        : allEntityFields.find((el) => el.name === getDependantField(col.name))
    };
  };

  toggleScheduleModal = () => {
    const formToValidate = cloneDeep(this.state.ticket);
    const validationResult = validateForm(formToValidate, newTicketConstraints);
    if (validationResult) {
      this.setState({ errors: validationResult });
      return;
    }
    this.setState({ errors: {} });
    this.setState({ scheduleModalOpen: !this.state.scheduleModalOpen });
  };

  getNameFromObj(userObj) {
    const { name, firstName, lastName, email } = userObj;
    if (firstName) {
      if (lastName) {
        return `${firstName} ${lastName}`;
      }
      return firstName;
    }
    if (name) {
      return name;
    }
    return email || '';
  }

  saveScheduledTicket = () => {};

  setMandatoryFieldsOnCreation = (args) => {
    this.setState({
      mandatoryFieldsOnCreation: args
    });
  };

  renderTechCell = () => {
    const { entitiesMeta } = this.props;
    const allEntityFields = getEntityAttributes(
      entitiesMeta,
      ENTITY_MAP.ticket
    );
    const field = allEntityFields.find((el) => el.name === 'technician');
    const { ticket } = this.state;
    const fieldValue = ticket['technician'];
    const defaultValue = this.getDefaultValue(fieldValue, 'technician');
    // const Tag = getTag(field);
    const allProps = this.getCellProps(field);

    return (
      <div className="flex center full-height technician-select">
        <Avatar
          size="small"
          customer={!ticket.technician && !ticket.techGroup}
          style="two"
          initials={
            ticket.technician
              ? `${ticket?.technician?.firstName?.[0]}${ticket?.technician?.lastName?.[0]}`
              : ticket?.techGroup?.name?.[0]
          }
        />
        <div className="full-width">
          <DualCell
            defaultValue={defaultValue}
            updateSelection={this.updateProperties}
            _ticket={ticket}
            field={field}
            params={allProps}
          />
        </div>
        <div
          className="pointer closeIcon"
          onClick={this.clearTechnician}
          aria-hidden
        >
          <SVGIcon name="Close" size="sm" />
        </div>
      </div>
    );
  };

  setImageUploading(value) {
    this.setState({ imageUploading: value });
  }

  toggleSheetActive = () =>
    this.setState({ sheetActive: !this.state.sheetActive });

  addedAssets = (selectedAssets) => {
    const currentAssets = this.state.ticket?.addAssets ?? [];

    if (selectedAssets.addAssets) {
      const selectedAssetsData = selectedAssets.addAssets.map((assetData) => {
        return pick(assetData, [
          'assetId',
          'name',
          'assetClass.classId',
          'assetClass.name'
        ]);
      });
      this.setState({
        ticket: {
          ...this.state.ticket,
          addAssets: [...currentAssets, ...selectedAssetsData]
        }
      });
    }

    if (selectedAssets.deleteAssets) {
      // Filter the assets array to exclude the assets to be deleted
      var updatedAssets = this.state.ticket?.addAssets.filter(
        (asset) =>
          !selectedAssets.deleteAssets
            .map((deleteAsset) => deleteAsset.assetId)
            .includes(asset.assetId)
      );
      this.setState({
        ticket: {
          ...this.state.ticket,
          addAssets: [...updatedAssets]
        }
      });
    }
  };

  // Function to get deflection suggestions
  getDeflectionSuggestions = (params) => {
    this.setState({ errors: {}, submitActionLoading: true });
    MLClient.query({
      query: GENERATE_TICKET_DEFLECTION_SUGGESTIONS_V2,
      variables: params,
      fetchPolicy: 'no-cache'
    })
      .then((response) => {
        if (response?.data?.generateTicketDeflectionSuggestionsV2) {
          // Check if suggestions are empty or not
          if (
            response?.data?.generateTicketDeflectionSuggestionsV2
              ?.aiGeneratedArticle
          ) {
            // If suggestions exist, show them in the popup
            this.setState({
              suggestions:
                response?.data?.generateTicketDeflectionSuggestionsV2,
              confirmDeflectionModalOpen: true,
              submitActionLoading: false
            });

            this.props?.useActivityTracker({
              event: 'KB_ARTICLE_TICKET_DEFLECTION',
              data: {
                stepName: 'TICKET_DEFLECTION_SUGGESTIONS_POPUP'
              }
            });
          } else {
            // If suggestions are empty, create the ticket directly
            this.setState({
              suggestions: ''
            });
            this.createTicket();
          }
        } else {
          // If no suggestions data, create the ticket
          this.setState({
            suggestions: ''
          });
          this.createTicket();
        }
      })
      .catch((error) => {
        console.error('Error fetching deflection suggestions', error);
        // If error, proceed with ticket creation
        this.createTicket();
      });
  };

  render() {
    const {
      ticket,
      selectedFormTemplate,
      errors,
      submitActionLoading,
      template,
      imageUploading,
      checkClient,
      associateTimer,
      sheetActive,
      isAssetAuthorised,
      isAssetGatingAvailable,
      confirmDeflectionModalOpen
    } = this.state;

    console.log(this.state.ticket, 'ash:: ticket');
    const { intl, appContext } = this.props;
    const isMSPProduct = appContext?.currentProduct === COMMON_CONSTANTS.MSP;
    const clientCondition = { joinOperator: 'AND', operands: [] };
    if (isMSPProduct) {
      clientCondition.operands.push({
        attribute: 'client.accountId',
        operator: 'is',
        value: ticket?.client?.accountId
      });
    } else {
      clientCondition.operands.push({
        attribute: 'site.id',
        operator: 'is',
        value: ticket?.site?.id
      });
    }
    const name =
      (ticket?.requester?.firstName || '') +
      (ticket?.requester?.lastName || '');

    return (
      <div className="p16 tab-page full-height fx g20 white-grey-page mauto mw1400">
        <div className="fg1">
          <Page
            variant="secondary"
            divider
            contentHeight="80px"
            title={
              <div className="fx center">
                <Heading element="h1">
                  <FormattedMessage id="app.create.ticket.new" />
                </Heading>
                {!checkClient && (
                  <div className="ml20 mt5 fx center">
                    <FeatureGuide featureName="creatingticket" video onlyIcon />
                  </div>
                )}
              </div>
            }
            primaryAction={
              <ButtonGroup>
                <Button
                  id="cancelTicketButton"
                  id={'cancelNewTicket'}
                  plainSecondary
                  onClick={this.cancel}
                >
                  <FormattedMessage id="common.cancel" />
                </Button>
                <Button
                  id={'saveNewTicket'}
                  loading={submitActionLoading}
                  primary
                  onClick={this.save}
                  disabled={imageUploading}
                  icon={<SVGIcon name="Save" color="#ffffff" />}
                  connectedDisclosure={
                    isAuthorised(
                      this.props.appContext?.user?.role?.roleFeatureList || [],
                      `ticketScheduler.add`
                    ) &&
                    !associateTimer && {
                      disabled: imageUploading,
                      actions: [
                        {
                          content: (
                            <ScheduleButton
                              className="fx"
                              onClick={this.toggleScheduleModal}
                            >
                              <SVGIcon name="DateTime" />
                              <span className="ml-10">
                                <FormattedMessage id="admin.ticketScheduler.create" />
                              </span>
                            </ScheduleButton>
                          )
                        }
                      ]
                    }
                  }
                >
                  <span className="fx actr">
                    <FormattedMessage id="common.save" />
                  </span>
                </Button>
              </ButtonGroup>
            }
          >
            <TicketScheduleModal
              ticketData={this.state}
              scheduleModalOpen={this.state.scheduleModalOpen}
              toggleScheduleModal={this.toggleScheduleModal}
            />

            <Wrapper>
              <div className="flex source g20 mt20 col pl20">
                <div className="flex actr pl20 pr30 g20 w100">
                  <AccessControl
                    roleToCheck="client.view"
                    productToCheck="MSP"
                    render={
                      <div className="fx w100 wm-215">
                        <ClientSelect
                          fetchBefore
                          prePopulateOptions={
                            this.state.checkClient && this.state.clientList
                          }
                          updateField={this.updateField}
                          property="accountId"
                          value="client"
                          selectedValue={ticket.client}
                          conditions={null}
                          query={GET_CLIENTS_FOR_DROPDOWN}
                          defaultValue={
                            ticket.client?.name && ticket.client?.label
                              ? [
                                  {
                                    name: ticket.client?.name,
                                    label: ticket.client?.name
                                  }
                                ]
                              : []
                          }
                          errors={errors?.['client.accountId']?.[0]}
                          fullWidth
                        />
                      </div>
                    }
                  />
                  <AccessControl
                    roleToCheck={{
                      operator: 'OR',
                      roles: ['site.view', 'companySite.view']
                    }}
                    render={
                      <div className="w100 wm-215">
                        <SiteSelect
                          accountId={ticket.client?.accountId}
                          prePopulateOptions={
                            this.state.checkClient &&
                            this.getSiteByOrgAccountId()
                          }
                          isMSPClientProduct={
                            this.isMSPClientProduct ? true : false
                          }
                          updateSite={(val, isResetUser) => {
                            this.updateField(
                              'site',
                              {
                                id: val.id,
                                name: val.name
                              },
                              {
                                additionalFields: true,
                                requester: isResetUser
                                  ? null
                                  : ticket.requester,
                                addAdditionalRequester: null
                              } // while updating site, reset the requester}
                            );
                          }}
                          site={ticket.site}
                          errors={errors?.['site.id']?.[0]}
                          hideLabel
                          icon
                          roundedIcon
                          fullWidth
                        />
                      </div>
                    }
                  />
                  <AccessControl
                    productToCheck={COMMON_CONSTANTS.IT}
                    roleToCheck="department.view"
                    render={
                      <div className="w100 wm-215">
                        <DepartmentSelect
                          onChange={(val) => {
                            if (val) {
                              this.updateField(
                                'department',
                                {
                                  businessFunctionId: val.value,
                                  name: val.name
                                },
                                {
                                  additionalFields: true
                                }
                              );
                            } else {
                              this.updateField('department', null);
                            }
                          }}
                          department={ticket.department}
                          showIcon
                        />
                      </div>
                    }
                  />
                  <div className="w100 wm-215">
                    <TicketTypeContainer
                      currentValue={ticket.ticketType}
                      onChange={this.updateField}
                      fullWidth
                    />
                  </div>

                  <div className="w100 wm-215">
                    <Query
                      query={this.getTicketFormsQuery(isMSPProduct)}
                      fetchPolicy="cache-and-network"
                      variables={
                        isMSPProduct && this.requesterGroupsFlag
                          ? {}
                          : {
                              input: {
                                user: {
                                  userId: this.state.ticket?.requester?.userId
                                }
                              }
                            }
                      }
                    >
                      {({ loading, error, data }) => {
                        if (loading)
                          return <Spinner size="small" color="inkLightest" />;
                        if (error) return `Error! ${error.message}`;

                        let forms = this.getFormsPayload(data, isMSPProduct);
                        forms = forms.map((el) => {
                          return {
                            ...el,
                            value: el.formName,
                            label: el.formName,
                            name: el.formName
                          };
                        });

                        forms = sortBy(forms, (el) => {
                          return el?.name.toString().toLowerCase();
                        });

                        const currentFormId = selectedFormTemplate?.formId;
                        const selectedForm = forms?.find(
                          (el) => el.formId === currentFormId
                        );

                        return (
                          <div
                            spacing="tight"
                            id="empDesigSelect"
                            className="formTemplates flex center select-container w100"
                          >
                            <Badge size="small" radial status="success">
                              <div className="opacity6 flex">
                                <SVGIcon name="Form" />
                              </div>
                            </Badge>
                            <div className="full-width ml8">
                              <Select
                                isClearable
                                value={selectedForm}
                                onChange={this.handleTemplateChange}
                                placeholder={getTranslatedText(
                                  intl,
                                  'ticket.new.pl.temp'
                                )}
                                name="forms"
                                options={forms}
                                classNamePrefix="value_selector"
                                components={{
                                  IndicatorSeparator,
                                  DropdownIndicator
                                }}
                                formatGroupLabel={formatGroupLabel}
                                menuPlacement="auto"
                                closeMenuOnScroll={(e) => {
                                  return (
                                    e.target &&
                                    e.target.classList &&
                                    !(
                                      e.target.classList.value.indexOf(
                                        'menu-list'
                                      ) > -1
                                    )
                                  );
                                }}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                  })
                                }}
                              />
                            </div>
                          </div>
                        );
                      }}
                    </Query>
                  </div>
                </div>
                <div
                  className={`flex actr w100 pl20 pr30 ${
                    isMSPProduct ? 'g20' : 'g25'
                  }`}
                >
                  <AccessControl
                    roleToCheck={{
                      operator: 'OR',
                      roles: ['users.view', 'employees.view']
                    }}
                    render={
                      <div className="w100 wm-215">
                        <UserSelect
                          noMargin
                          fetchBefore
                          createRequester={
                            this.props?.flags?.creareRequesterFromTicket
                          }
                          client={ticket.client}
                          updateField={(key, value, additionalProps) => {
                            // auto update department field - only for IT product
                            const departmentProps = additionalProps
                              ? {
                                  department: additionalProps.businessFunction
                                }
                              : null;
                            this.updateField(key, value, {
                              additionalFields: !isMSPProduct,
                              ...departmentProps
                            });
                          }}
                          property="userId"
                          placeholder={
                            !isMSPProduct &&
                            getTranslatedText(intl, 'itsm.choose.user')
                          }
                          field="requester"
                          value={ticket.requester}
                          defaultValue={
                            name ? [{ name: name, label: name }] : []
                          }
                          errors={errors?.['requester.userId']?.[0]}
                          sortList
                          showEmail
                          site={ticket?.site}
                          department={ticket?.department}
                          showInitials
                          dropDownComponents={{
                            IndicatorSeparator
                          }}
                        />
                      </div>
                    }
                    fallback={
                      this.props.isMsp ? null : (
                        <RequesterUserContainer className="fx center mr-20">
                          <Avatar
                            size="small"
                            name="requesters"
                            source={`${envConfig.imageRoot}svg/requesters_white.svg`}
                          />
                          <div className="ml-10 mr-10">
                            {this.getNameFromObj(this.props.appContext?.user)}
                          </div>
                        </RequesterUserContainer>
                      )
                    }
                  />

                  <AccessControl
                    roleToCheck="employees.view"
                    render={
                      <Field className="w100 wm-215">
                        {this.renderTechCell()}
                      </Field>
                    }
                  />
                </div>

                <AccessControl
                  roleToCheck="client.view"
                  productToCheck="MSP"
                  render={
                    <div className="flex w100 pl20 pr30 g20">
                      <div className="w100 wm-215 mr-5">
                        {this.state.showAdditionalRequester ? (
                          <>
                            <UserSelect
                              noMargin
                              isMulti
                              fetchOnOpen
                              client={ticket?.client}
                              updateField={(key, value, additionalProps) => {
                                const usersArr = !isEmpty(additionalProps)
                                  ? Object.values(additionalProps)
                                  : null;
                                if (usersArr) {
                                  const formattedUsers = usersArr?.map(
                                    ({
                                      name,
                                      label,
                                      value,
                                      userId,
                                      firstName,
                                      lastName,
                                      email
                                    }) => ({
                                      name,
                                      label,
                                      value,
                                      userId,
                                      firstName,
                                      lastName,
                                      email
                                    })
                                  );
                                  this.updateField(
                                    'addAdditionalRequester',
                                    formattedUsers || null
                                  );
                                } else {
                                  this.updateField(
                                    'addAdditionalRequester',
                                    null
                                  );
                                }
                              }}
                              property="userId"
                              placeholder={getTranslatedText(
                                intl,
                                'placeholder.ticket.additionalRequester'
                              )}
                              field="addAdditionalRequester"
                              sortList
                              site={ticket?.site}
                              department={ticket?.department}
                              allowAdditionalProps
                              defaultMenuIsOpen={
                                !!ticket?.client?.accountId &&
                                isEmpty(
                                  this.state.ticket?.addAdditionalRequester
                                )
                              }
                              value={ticket?.addAdditionalRequester || []}
                              defaultValue={
                                ticket?.addAdditionalRequester || []
                              }
                              dropDownComponents={{
                                IndicatorSeparator
                              }}
                              // dropDownComponents={{
                              //   IndicatorSeparator,
                              // }}
                              // dropDownComponents={
                              //   {
                              //     // IndicatorSeparator,
                              //     // DropdownIndicator
                              //   }
                              // }
                              preventSiteCondition
                            />
                          </>
                        ) : (
                          <Button
                            icon={<SVGIcon name="Add" />}
                            plain
                            onClick={() => {
                              this.setState({
                                showAdditionalRequester: true
                              });
                            }}
                          >
                            <FormattedMessage id="placeholder.ticket.additionalRequester" />
                          </Button>
                        )}
                      </div>
                    </div>
                  }
                />
              </div>

              <TicketForm
                ticket={ticket}
                updateField={this.updateField}
                errors={this.state.errors}
                template={template}
                selectedFormTemplate={selectedFormTemplate}
                updateTemplate={this.updateTemplate}
                handleFileAttachments={this.handleFileAttachments}
                handleAttachmentsDeletion={this.handleAttachmentsDeletion}
                updateSelectedFormTemplate={this.updateSelectedFormTemplate}
                mandatoryFieldsOnCreation={this.state.mandatoryFieldsOnCreation}
                setMandatoryFieldsOnCreation={this.setMandatoryFieldsOnCreation}
              />
            </Wrapper>
          </Page>
          <Modal
            open={confirmDeflectionModalOpen}
            title={getTranslatedText(intl, 'ai.ticket.deflection.v2.title')}
            showCloseButton={false}
            large
            secondaryActions={{
              content: (
                <Button icon={<SVGIcon name="ThumbsDownOutline" />}>
                  <span className="fx actr">
                    <TextStyle>
                      {getTranslatedText(
                        intl,
                        'ai.ticket.deflection.v2.nothelpful.btn'
                      )}
                    </TextStyle>
                  </span>
                </Button>
              ),
              onAction: () =>
                this.createTicket({
                  event: 'KB_ARTICLE_TICKET_DEFLECTION',
                  data: {
                    stepName: 'SUGGESTION_NOT_HELPFUL'
                  }
                }),
              loading: submitActionLoading
            }}
            primaryAction={{
              icon: <SVGIcon name="LikeThumb" />,
              content: getTranslatedText(
                intl,
                'ai.ticket.deflection.v2.helpful.btn'
              ),
              onAction: () =>
                this.closeDeflectionModal({
                  event: 'KB_ARTICLE_TICKET_DEFLECTION',
                  data: {
                    stepName: 'SUGGESTION_HELPFUL'
                  }
                })
            }}
            dialogClassName="kb-relevant-article-wrapper"
          >
            <Modal.Section>
              <KbRelevantArticle suggestions={this.state.suggestions} />
            </Modal.Section>
          </Modal>
        </div>
        <div className="fx col g15">
          {associateTimer && (
            <WorkLogHourSectionContainer className="fw min-width-350">
              <WorklogHoursSection
                editMode
                hideCancel
                hideDelete
                noBoxShadow
                highlightRunningTimer
                timer={associateTimer}
                forwardedRef={this.timerRef}
                workItem={associateTimer?.workItem}
                module={associateTimer?.module || null}
                onlyManual={associateTimer?.type !== 'AUTOMATIC'}
              />
            </WorkLogHourSectionContainer>
          )}
          {this.props?.flags?.agentChatFe && isAssetGatingAvailable && (
            <div className="fw min-width-350 wm-450">
              <Card padding="sizeSmall">
                <div className="flex fx-sb actr w100 mb10">
                  <div>
                    <TextStyle weight="SemiBold">
                      <FormattedMessage id="ticket.details.insights.assets" />
                    </TextStyle>
                  </div>
                  <div>
                    <AccessControl
                      roleToCheck={{
                        operator: 'AND',
                        roles: ['tickets.edit', 'asset.view']
                      }}
                      render={
                        <div className="mlauto">
                          <Button
                            onClick={this.toggleSheetActive}
                            size="tiny"
                            plain
                            monochrome
                            icon={<SVGIcon name="Add" />}
                          />
                        </div>
                      }
                    />
                    {sheetActive && (
                      <TicketAssetsSheet
                        toggleSheetActive={this.toggleSheetActive}
                        // refetchAssets={refetchAssets}
                        ticketAssets={ticket?.addAssets}
                        addedAssets={this.addedAssets}
                        ticket={ticket}
                        open={sheetActive}
                        newTicket
                      />
                    )}
                  </div>
                </div>
                <div className="max-height-150 overflow-y-scroll x-hidden">
                  {ticket?.addAssets?.length > 0 ? (
                    ticket?.addAssets.map((el) => {
                      return (
                        <div className="flex asset actr hiddenContainer lh-40">
                          <AssetTypeCell cell={{ row: { original: el } }} />
                          <div
                            className="ellipsis ml8"
                            onClick={() => {
                              if (isAssetAuthorised) {
                                tabContext.openTab({
                                  module: 'ASSET_DETAILS',
                                  data: {
                                    id: el.assetId,
                                    classId: el?.assetClass?.classId,
                                    subject: el?.name
                                  }
                                });
                              }
                            }}
                          >
                            <TextStyle weight="Medium">{el?.name}</TextStyle>
                          </div>
                          <div className="mlauto flex-row flex-align-center">
                            <AccessControl
                              roleToCheck="tickets.edit"
                              render={
                                <div className="hiddenActions">
                                  <Button
                                    onClick={this.addedAssets.bind(this, {
                                      deleteAssets: [el]
                                    })}
                                    icon={
                                      <SVGIcon
                                        size="sm"
                                        name="RejectedCircle"
                                        color="var(--sops-black-white-bg)"
                                      />
                                    }
                                  />
                                </div>
                              }
                            />
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <div>
                        <FormattedMessage id="ticket.details.insights.assets.noAssets" />
                      </div>
                    </>
                  )}
                </div>
                {isAssetAuthorised && (
                  <div className="mt10">
                    <div className="mb10">
                      <TextStyle weight="SemiBold">
                        <FormattedMessage id="ticket.details.insights.requesterassets" />
                      </TextStyle>
                    </div>
                    <div>
                      <AssociateAssets
                        assets={ticket?.addAssets}
                        addedAssets={this.addedAssets}
                        ticket={ticket}
                      />
                    </div>
                  </div>
                )}
              </Card>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(TicketSheet);
